import { render, staticRenderFns } from "./MarketProduct.vue?vue&type=template&id=28b7bff0&"
import script from "./MarketProduct.vue?vue&type=script&lang=js&"
export * from "./MarketProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports